jQuery(function ($) {
  $('.wp-block-sivananda-blocks-events-list').each(function () {
    let $block = $(this);
    let yearMonth = $block.data('year-month');

    if (!yearMonth) {
      return;
    }

    $articles = $block.find('article');

    $articles.filter(function () {
      let $article = $(this);
      let $time = $article.find('time');
      let dateTimeString = $time.attr('datetime');

      return !(dateTimeString.startsWith(yearMonth));
    }).remove();
  });
});